import createReducer from './_createReducerHelper';

export const CHARTSDATA = 'charts-data/CHARTSDATA';

const initialState = {
  chartsData: [],
};

/** ********************************************
 * reducer
 ******************************************** */

export default createReducer(initialState, {
  [CHARTSDATA]: (state, { payload }) => ({ ...state, chartsData: payload }),
});

/** ********************************************
 * actions
 ******************************************** */

/**
 *
 * @param chartsData
 * @return {{type, payload: *}}
 */
export const setChartsData = (chartsData) => ({
  type: CHARTSDATA,
  payload: chartsData,
});

/** ********************************************
 * selectors
 ******************************************** */

/**
 *
 * @param state
 */
export const readStateChartsData = (state) => state.chartsData.chartsData;
